import React from 'react';

import { MenuItem, Select } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';

import { CONDITION_APPLY_TYPES, type ConditionApplyType } from '~/components/Vouchers/voucherConditionEditConstants';
import { formatApplyTypeLabel } from '~/components/Vouchers/voucherConditionFormatters';

type ApplyTypeEditCellProps = GridRenderEditCellParams & {
  applyTypes?: ReadonlyArray<ConditionApplyType>;
};

export default function ApplyTypeEditCell({ id, field, value, applyTypes }: ApplyTypeEditCellProps) {
  const apiRef = useGridApiContext();
  const types = applyTypes && applyTypes.length > 0 ? applyTypes : CONDITION_APPLY_TYPES;
  const fallback = types[0] ?? 'NONE';
  const selectedValue = types.includes(value as ConditionApplyType) ? value : fallback;
  return (
    <Select
      value={selectedValue || fallback}
      onChange={(event) => apiRef.current.setEditCellValue({ id, field, value: event.target.value })}
      size="small"
      fullWidth
    >
      {types.map((type) => (
        <MenuItem key={type} value={type}>
          {formatApplyTypeLabel(type)}
        </MenuItem>
      ))}
    </Select>
  );
}
